import * as caseFilterStore from './caseFilter.js';
import filterBadges from './filterBadges.js';
export const getBadgesToShow = (caseFilter, lang, propertyTypes = []) => {
    const badges = [];
    Object.keys(caseFilter).forEach((key) => {
        const k = key;
        const filter = caseFilter[k];
        if (Array.isArray(filter) && filter.length === 0) {
            return;
        }
        if (typeof filter === 'object' && !Array.isArray(filter)) {
            if (typeof filterBadges[k] === 'object') {
                Object.keys(filter).forEach((childKey) => {
                    badges.push({
                        onDeactivate: () => caseFilterStore.clearFilter(k, true, childKey),
                        // @ts-expect-error
                        label: filterBadges[k][childKey](caseFilter, lang),
                    });
                });
                return;
            }
        }
        badges.push({
            onDeactivate: () => caseFilterStore.clearFilter(k),
            // @ts-expect-error
            label: filterBadges[k](caseFilter, lang, propertyTypes),
        });
    });
    return badges;
};
//# sourceMappingURL=selectors.js.map